import { 
    CreateRatePerPaxDto, 
    DeleteRatePerPaxDto,
    EditRatePerPaxDto,
    GetRatePerPaxDto, 
    MessageResponseDto, 
    RatePerPaxApiFp,
    RatePerPaxControllerGet200Response,
} from "@api/api";
import { apiConfig } from "@factory/query/config";
import { QueryKey } from "@factory/query/query-key.enum";

export type GetResponseRatePerPaxModel = RatePerPaxControllerGet200Response;
export type GetRatePerPaxModel = GetRatePerPaxDto;
export type MutateResponseRatePerPaxModel = MessageResponseDto;
export type CreateRatePerPaxModel = CreateRatePerPaxDto;
export type UpdateRatePerPaxModel = EditRatePerPaxDto;
export type DeleteRatePerPaxModel = DeleteRatePerPaxDto;

export const apiRatePerPaxFp = RatePerPaxApiFp(apiConfig);
export const getRatePerPaxController = apiRatePerPaxFp.ratePerPaxControllerGet;
export const createRatePerPaxController = apiRatePerPaxFp.ratePerPaxControllerCreate;
export const updateRatePerPaxController = apiRatePerPaxFp.ratePerPaxControllerEdit;
export const deleteRatePerPaxController = apiRatePerPaxFp.ratePerPaxControllerDelete;

export const QueryKeyRatePerPax = QueryKey.RatePerPax;